import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import SectionHeader from './SectionHeader';

import css from './Sections.module.css';

const STEPS = ['list', 'ship', 'paid'];

/** Selling on TradMarket: three steps on the brand's dark green, and the way in. */
function SectionSell(props) {
  const { intl } = props;
  return (
    <section className={css.sellBand}>
      <div className={css.stavesTop} aria-hidden="true" />
      <div className={css.stavesBottom} aria-hidden="true" />
      <div className={css.container}>
        <div className={css.sellInner}>
          <div className={css.sellHead}>
            <SectionHeader
              onDark
              eyebrow={intl.formatMessage({ id: 'SectionSell.eyebrow' })}
              title={intl.formatMessage({ id: 'SectionSell.title' })}
              className={css.sellTitle}
            />
            <NamedLink name="NewListingPage" className={css.buttonWhite}>
              <FormattedMessage id="SectionSell.cta" />
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                aria-hidden="true"
              >
                <path d="M5 12h14M13 6l6 6-6 6" />
              </svg>
            </NamedLink>
          </div>
          <ol className={css.steps}>
            {STEPS.map((step, index) => (
              <li key={step} className={css.step}>
                <span className={css.stepNumber}>{String(index + 1).padStart(2, '0')}</span>
                <span className={css.stepText}>
                  <span className={css.stepTitle}>
                    <FormattedMessage id={`SectionSell.${step}Title`} />
                  </span>
                  <span className={css.stepBody}>
                    <FormattedMessage id={`SectionSell.${step}Text`} />
                  </span>
                </span>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}

export default SectionSell;
